import { render } from "./BetaOverNotification.vue?vue&type=template&id=bfceee04&scoped=true"
import script from "./BetaOverNotification.vue?vue&type=script&lang=js"
export * from "./BetaOverNotification.vue?vue&type=script&lang=js"

import "./BetaOverNotification.vue?vue&type=style&index=0&id=bfceee04&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfceee04"]])

export default __exports__